import { createFileRoute } from '@tanstack/react-router'

import { tambahPesananSearchSchema } from '@/features/order-management/mode'
import { TambahPesananPage } from '@/features/order-management/components/TambahPesananPage'
import { groupsInfiniteQueryOptions } from '@/features/group/queries'

export const Route = createFileRoute('/_authed/order-management/new')({
  validateSearch: tambahPesananSearchSchema,
  loader: ({ context }) =>
    context.queryClient.infiniteQuery(groupsInfiniteQueryOptions()).catch(() => undefined),
  component: RouteComponent,
})

function RouteComponent() {
  const { mode, returnTo } = Route.useSearch()
  return <TambahPesananPage mode={mode} returnTo={returnTo} />
}
